/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `MapLabel.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { MapLabel } from "./MapLabel";

import { MapObject } from "./MapObject";

export type anchor =
    | "center"
    | "left"
    | "right"
    | "top"
    | "bottom"
    | "top_left"
    | "top_right"
    | "bottom_left"
    | "bottom_right";
export type placement = "point" | "line" | "line_center" | "custom";

export const anchorValues = {
    center: 0,
    left: 1,
    right: 2,
    top: 3,
    bottom: 4,
    top_left: 5,
    top_right: 6,
    bottom_left: 7,
    bottom_right: 8,
};
export const placementValues = { point: 0, line: 1, line_center: 2, custom: 3 };

export abstract class MapLabelModel {
    id: number;
    anchor: anchor;
    coordinates: any | null;
    createdAt: Dayjs;
    mapObjectId: number;
    placement: placement;
    showLeaderLine: boolean;
    text: string | null;
    updatedAt: Dayjs;
    mapObject: MapObject | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        anchor: anchor,
        coordinates: any | null,
        createdAt: Dayjs,
        mapObjectId: number,
        placement: placement,
        showLeaderLine: boolean,
        text: string | null,
        updatedAt: Dayjs,
        mapObject: MapObject | null | undefined
    ) {
        this.id = id;
        this.anchor = anchor;
        this.coordinates = coordinates;
        this.createdAt = createdAt;
        this.mapObjectId = mapObjectId;
        this.placement = placement;
        this.showLeaderLine = showLeaderLine;
        this.text = text;
        this.updatedAt = updatedAt;
        this.mapObject = mapObject;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): MapLabel {
        const newObject = new MapLabel(
            json["id"],
            json["anchor"],
            json["coordinates"],
            dayjs(json["created_at"]).tz(timezone),
            json["map_object_id"],
            json["placement"],
            json["show_leader_line"],
            json["text"],
            dayjs(json["updated_at"]).tz(timezone),
            json["map_object"] == null ? json["map_object"] : MapObject.fromApiObject(json["map_object"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            anchor: this.anchor,
            coordinates: this.coordinates,
            created_at: this.createdAt,
            map_object_id: this.mapObjectId,
            placement: this.placement,
            show_leader_line: this.showLeaderLine,
            text: this.text,
            updated_at: this.updatedAt,
            map_object_attributes: this.mapObject?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): MapLabel {
        const clone = Object.create(this) as MapLabel;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
